import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import Notifications from 'vue-notification'
Vue.use(Notifications)
// import VueRouter from 'vue-router'
// import router from './router'

// Vue.use(VueRouter)

Vue.config.productionTip = false

new Vue({
  // router,
  render: h => h(App)
}).$mount('#app')